import React from 'react';
import ShowLoader from '../../../../hoc/ShowLoader/ShowLoader';
import DailyFeedbackSection from '../../../ReportsPageTabs/DailyFeedbackSection/DailyFeedbackSection';
import DailyFeedbackSectionNewPM from '../../../ReportsPageTabs/DailyFeedbackSectionNewPM/DailyFeedbackSectionNew';
import WeeklyFeedbackSection from '../../../ReportsPageTabs/WeeklyFeedbackSection/WeeklyFeedbackSection';
import Tabs from '../../../UI/Tabs/Tabs';

import classes from './FeedbackTab.module.css';

class FeedbackTab extends React.Component {

    state = {
        tabs: [
            {
                id: 0,
                label: 'SESSION',
                type: 'session-feedback'
            },
            {
                id: 1,
                label: 'WEEEKLY',
                type: 'weekly-feedback'
            }
        ],
        currentTabId: 0,
        loadingData: false,
    }

    onTabClick = (id) => {
        this.setState({ currentTabId: id });
        const feedbackType = this.state.tabs[id].type;
        this.props.setNewURL(feedbackType, '');
    }

    setNewURL = (feedbackId) => {
        const feedbackType = this.state.tabs[this.state.currentTabId].type;
        this.props.setNewURL(feedbackType, feedbackId);
    }

    setActiveFeedbackTab = () => {
        const activeTabPos = this.props.pathname.indexOf('weekly-feedback') !== -1 ? 1 : 0;
        if (this.state.currentTabId !== activeTabPos) {
            this.setState({ currentTabId: activeTabPos });
        }
    }

    componentDidMount() {
        this.setActiveFeedbackTab();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.pathname !== this.props.pathname) {
            this.setActiveFeedbackTab();
        }
    }

    render() {

        let tabPos = 0, tabsList = this.state.tabs;
        for (let item in tabsList) {
            if (tabsList[item].id === this.state.currentTabId) {
                tabPos = item;
            }
        }

        let renderResults = '';

        switch (parseInt(tabPos, 10)) {
            case 0:
                if (this.state.loadingData) {
                    renderResults =
                        <div className={classes.LoaderContainer}>
                            <ShowLoader isLoading={this.state.loadingData} />
                        </div>
                } else {
                    renderResults = <DailyFeedbackSectionNewPM
                        forPMPage={true}
                        batchCode={this.props.activeProgramBatchCode}
                        moduleName={this.props.activeModuleName}
                        params={this.props.params}
                        setNewURL={this.setNewURL}

                        onFailureDialogShow={this.props.onFailureDialogShow}
                        redirectToUnauthorized={this.props.redirectToUnauthorized}
                        showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                        redirectToNotFound={this.props.redirectToNotFound}
                        redirectToServerError={this.props.redirectToServerError}
                    />
                }
                break;
            case 1:
                if (this.state.loadingData) {
                    renderResults =
                        <div className={classes.LoaderContainer}>
                            <ShowLoader isLoading={this.state.loadingData} />
                        </div>
                } else {
                    renderResults = <WeeklyFeedbackSection
                        forPMPage={true}
                        batchCode={this.props.activeProgramBatchCode}
                        moduleName={this.props.activeModuleName}

                        onFailureDialogShow={this.props.onFailureDialogShow}
                        redirectToUnauthorized={this.props.redirectToUnauthorized}
                        showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                        redirectToNotFound={this.props.redirectToNotFound}
                        redirectToServerError={this.props.redirectToServerError}
                    />
                }
                break;

            default:
                if (this.state.loadingData) {
                    renderResults =
                        <div className={classes.LoaderContainer}>
                            <ShowLoader isLoading={this.state.loadingData} />
                        </div>
                } else {
                    renderResults = <DailyFeedbackSectionNewPM
                        forPMPage={true}
                        batchCode={this.props.activeProgramBatchCode}
                        moduleName={this.props.activeModuleName}
                        params={this.props.params}
                        setNewURL={this.setNewURL}

                        onFailureDialogShow={this.props.onFailureDialogShow}
                        redirectToUnauthorized={this.props.redirectToUnauthorized}
                        showSessionExpiredDialog={this.props.showSessionExpiredDialog}
                        redirectToNotFound={this.props.redirectToNotFound}
                        redirectToServerError={this.props.redirectToServerError}
                    />
                }
        }

        return (
            <div className={classes.FeedbackTabContainer}>

                <div className={classes.Tabs}>
                    <Tabs
                        tabList={this.state.tabs}
                        onTabClick={this.onTabClick}
                        currentTab={this.state.currentTabId}
                    />
                </div>

                <div className={classes.TabData}>
                    {
                        this.state.showError
                            ? <p>Data not available.</p>
                            : renderResults
                    }
                </div>
            </div>
        );
    }
}

export default FeedbackTab;